// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kds-redo-accept-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  padding: 20px 24px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.kds-redo-accept-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.kds-redo-accept-title {
  font-size: calc(28px + var(--kds-font-delta, 0px));
  font-weight: 500;
  letter-spacing: -0.02em;
  color: #0f172a;
  margin: 0;
  line-height: 1.2;
}

.kds-redo-accept-count {
  display: inline-flex;
  height: 32px;
  min-width: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: #f1f5f9;
  padding: 0 12px;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 600;
  color: #475569;
  box-sizing: border-box;
}

.kds-redo-accept-close-btn {
  display: inline-flex;
  height: 36px;
  width: 36px;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  color: #64748b;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  cursor: pointer;
  padding: 0;
}

.kds-redo-accept-close-btn:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
  color: #0f172a;
}

.kds-redo-accept-close-btn svg {
  width: 16px;
  height: 16px;
}

.kds-redo-accept-search-section {
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
  padding: 16px 24px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.kds-redo-accept-search-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;
  align-items: center;
}

@media (min-width: 768px) {
  .kds-redo-accept-search-grid {
    grid-template-columns: minmax(0, 1fr) 240px;
  }
}

.kds-redo-accept-search-wrapper {
  position: relative;
  width: 100%;
}

.kds-redo-accept-search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #94a3b8;
  pointer-events: none;
}

.kds-redo-accept-search-input {
  display: flex;
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  border-radius: 20px;
  border: 1px solid #cbd5e1;
  border-color: #e2e8f0;
  background-color: #ffffff;
  padding: 4px 12px 4px 44px;
  font-size: calc(15px + var(--kds-font-delta, 0px));
  color: #1e293b;
  outline: none;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.kds-redo-accept-search-input::placeholder {
  color: #94a3b8;
}

.kds-redo-accept-search-input:focus {
  border-color: #cbd5e1;
}

.kds-redo-accept-scroll-viewport {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

.kds-redo-accept-scroll-viewport::-webkit-scrollbar {
  width: 6px;
}

.kds-redo-accept-scroll-viewport::-webkit-scrollbar-track {
  background: transparent;
}

.kds-redo-accept-scroll-viewport::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
  transition: background 0.2s ease;
}

.kds-redo-accept-scroll-viewport::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.kds-redo-accept-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
}

@media (min-width: 768px) {
  .kds-redo-accept-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1200px) {
  .kds-redo-accept-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.KdsCompLoaderContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
  background-color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/RedoAcceptModal/RedoAcceptModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iDAAiD;EACjD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc;EACd,2CAA2C;EAC3C,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,kDAAkD;EAClD,cAAc;EACd,aAAa;EACb,wEAAwE;AAC1E;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,yBAAyB;AAC3B","sourcesContent":[".kds-redo-accept-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  padding: 20px 24px;\n  box-sizing: border-box;\n  background-color: #ffffff;\n}\n\n.kds-redo-accept-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.kds-redo-accept-title {\n  font-size: calc(28px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  margin: 0;\n  line-height: 1.2;\n}\n\n.kds-redo-accept-count {\n  display: inline-flex;\n  height: 32px;\n  min-width: 32px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  background-color: #f1f5f9;\n  padding: 0 12px;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  color: #475569;\n  box-sizing: border-box;\n}\n\n.kds-redo-accept-close-btn {\n  display: inline-flex;\n  height: 36px;\n  width: 36px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  color: #64748b;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n  cursor: pointer;\n  padding: 0;\n}\n\n.kds-redo-accept-close-btn:hover {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.kds-redo-accept-close-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.kds-redo-accept-search-section {\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n  padding: 16px 24px;\n  box-sizing: border-box;\n  background-color: #ffffff;\n}\n\n.kds-redo-accept-search-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr;\n  align-items: center;\n}\n\n@media (min-width: 768px) {\n  .kds-redo-accept-search-grid {\n    grid-template-columns: minmax(0, 1fr) 240px;\n  }\n}\n\n.kds-redo-accept-search-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.kds-redo-accept-search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.kds-redo-accept-search-input {\n  display: flex;\n  width: 100%;\n  height: 44px;\n  box-sizing: border-box;\n  border-radius: 20px;\n  border: 1px solid #cbd5e1;\n  border-color: #e2e8f0;\n  background-color: #ffffff;\n  padding: 4px 12px 4px 44px;\n  font-size: calc(15px + var(--kds-font-delta, 0px));\n  color: #1e293b;\n  outline: none;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.kds-redo-accept-search-input::placeholder {\n  color: #94a3b8;\n}\n\n.kds-redo-accept-search-input:focus {\n  border-color: #cbd5e1;\n}\n\n.kds-redo-accept-scroll-viewport {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 20px 24px;\n  box-sizing: border-box;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n}\n\n.kds-redo-accept-scroll-viewport::-webkit-scrollbar {\n  width: 6px;\n}\n\n.kds-redo-accept-scroll-viewport::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.kds-redo-accept-scroll-viewport::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 10px;\n  transition: background 0.2s ease;\n}\n\n.kds-redo-accept-scroll-viewport::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.kds-redo-accept-grid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 768px) {\n  .kds-redo-accept-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1200px) {\n  .kds-redo-accept-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.KdsCompLoaderContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  flex: 1;\n  background-color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
